/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetEventOffsetEUMarker {
  size?: number,
  arrowColor?: string,
  fillColor?: string,
  opacity?: number,
  version2?: boolean
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for moving events of the asset
 *
 * ```typescript
 *  import {getAssetEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetEventOffsetEUMarker({size, outlineColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : angle - 90
 * }
 * ```
 */
export const getAssetEventOffsetEUMarker = ({
  fillColor = dlsColor('grey4'),
  arrowColor = dlsColor('white'),
  size = 24,
  opacity = 1
}: AssetEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${size}' height=${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 13.2C6.03532 13.2 1.2 18.0353 1.2 24C1.2 29.9647 6.03532 34.8 12 34.8C17.9647 34.8 22.8 29.9647 22.8 24C22.7934 18.0381 17.9619 13.2066 12 13.2Z' fill='${arrowColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 33C7.02943 33 3 28.9706 3 24C3 19.0294 7.02943 15 12 15C16.9706 15 21 19.0294 21 24C20.9944 28.9683 16.9683 32.9944 12 33Z' fill='${fillColor}' opacity='${opacity}' stroke='white'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 16L6 29.5L12 26.5L18 29.5L12 16Z' fill='${arrowColor}'/>
    </svg>
  `);

  return convertSvgToDataUri(svg.trim());
};

export default getAssetEventOffsetEUMarker;
